function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("rect", {
  width: 176,
  height: 26,
  rx: 13,
  fill: "#FEF0E3"
});

var _ref3 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0_55237_50449)"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M160.701 5.7364C160.889 5.64255 161.11 5.64255 161.297 5.7364L167.964 9.06973C168.19 9.18266 168.333 9.4135 168.333 9.66602C168.333 9.91853 168.19 10.1494 167.964 10.2623L161.297 13.5956C161.11 13.6895 160.889 13.6895 160.701 13.5956L154.035 10.2623C153.809 10.1494 153.666 9.91853 153.666 9.66602C153.666 9.4135 153.809 9.18266 154.035 9.06973L160.701 5.7364ZM155.823 9.66602L160.999 12.254L166.175 9.66602L160.999 7.07804L155.823 9.66602Z",
  fill: "#F47F4D"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M153.737 16.0347C153.901 15.7054 154.302 15.5719 154.631 15.7365L160.999 18.9208L167.368 15.7365C167.697 15.5719 168.098 15.7054 168.262 16.0347C168.427 16.364 168.294 16.7645 167.964 16.9291L161.298 20.2624C161.11 20.3563 160.889 20.3563 160.701 20.2624L154.035 16.9291C153.705 16.7645 153.572 16.364 153.737 16.0347Z",
  fill: "#F47F4D"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M153.737 12.7027C153.901 12.3733 154.302 12.2399 154.631 12.4045L160.999 15.5888L167.368 12.4045C167.697 12.2399 168.098 12.3733 168.262 12.7027C168.427 13.032 168.294 13.4324 167.964 13.5971L161.298 16.9304C161.11 17.0243 160.889 17.0243 160.701 16.9304L154.035 13.5971C153.705 13.4324 153.572 13.032 153.737 12.7027Z",
  fill: "#F47F4D"
}));

var _ref4 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_55237_50449"
}, /*#__PURE__*/React.createElement("rect", {
  width: 16,
  height: 16,
  fill: "white",
  transform: "translate(153 5)"
})));

var SvgSeasonDescription = function SvgSeasonDescription(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 176,
    height: 26,
    viewBox: "0 0 176 26",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSeasonDescription, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/season-description.48387275.svg";
export { ForwardRef as ReactComponent };